export default {
  name: "wishlistAboutSection",
};
